import styled from '@emotion/styled';
import { casinoColors } from 'src/assets/colors';
import { fontSize, fontWeight } from 'src/assets/fonts-config';

interface CategoryWrapperPropsType {
    isDragOver: boolean;
    order: number;
}

export const CategoryWrapper = styled('div', { label: 'CategoryWrapper' })<CategoryWrapperPropsType>`
    border: ${({ isDragOver }): string => isDragOver ? `1px dashed ${casinoColors.coolBlue}` : ''};
    filter: ${({ isDragOver }): string => isDragOver ? 'opacity(0.5)' : 'opacity:(1)'};
    margin-bottom: 8px;
    order: ${({ order }): number => order};
    &:last-of-type {
        margin-bottom: 0;
    }
`;

interface GameElementPropsType {
    isVisible: boolean;
}

export const GameElement = styled('li', { label: 'GameElement' })<GameElementPropsType>`
    list-style: none;
    height: ${({ isVisible }): string => isVisible ? 'auto' : '0'};
    opacity: ${({ isVisible }): string => isVisible ? '1' : '0'};
    visibility: ${({ isVisible }): string => isVisible ? 'visible' : 'hidden'};
    ${({ isVisible }): string => isVisible ? '' : 'overflow: hidden'};
`;

export const GameList = styled('ul', { label: 'GameList' })`
    padding: 0;
    margin: 0;
`;

export const DragDrop = styled('div', { label: 'DragDrop' })`
    background: ${casinoColors.bgColorGameRow};
    color: ${casinoColors.txtColorInfo};
    font-size: ${fontSize.small};
    font-weight: ${fontWeight.bold};
    line-height: 16px;
    padding: 16px 0;
    text-align: center;
`;
